import { COMPANY_INFO_ROUTE, COMPANY_INTEGRATIONS_ROUTE, COMPANY_WIDGET_ROUTE, USERS_ROUTE } from '@constants/routes';
import { TFunction } from 'i18next';

export const INFO_PAGE_ID = 'info';
export const INTEGRATIONS_PAGE_ID = 'integrations';
export const USERS_PAGE_ID = 'users';
export const WIDGET_PAGE_ID = 'widget';

export const getCompanyTabs = ({
  companyId,
  clubSlug,
  isEnabledCompanyInfo,
  isEnabledUsers,
  isEnabledWidget,
  t,
}: {
  companyId: string;
  clubSlug: string;
  t: TFunction;
  isEnabledCompanyInfo: boolean;
  isEnabledUsers: boolean;
  isEnabledWidget: boolean;
}) => {
  const infoTab = {
    id: INFO_PAGE_ID,
    name: t('companySettings:navigationTabLabel'),
    href: COMPANY_INFO_ROUTE.replace(':companyId', companyId).replace(':clubSlug', clubSlug),
  };

  const usersTab = {
    id: USERS_PAGE_ID,
    name: t('userManagement:tabUsers'),
    href: USERS_ROUTE.replace(':companyId', companyId).replace(':clubSlug', clubSlug),
  };

  const integrationsTab = {
    id: INTEGRATIONS_PAGE_ID,
    name: t('companyIntegrations:navigationTabLabel'),
    href: COMPANY_INTEGRATIONS_ROUTE.replace(':companyId', companyId).replace(':clubSlug', clubSlug),
  };

  const widgetTab = {
    id: WIDGET_PAGE_ID,
    name: t('companyWidget:navigationTabLabel'),
    href: COMPANY_WIDGET_ROUTE.replace(':companyId', companyId).replace(':clubSlug', clubSlug),
  };

  const tabs: (typeof infoTab)[] = [];

  if (isEnabledCompanyInfo) {
    tabs.push(infoTab, integrationsTab);
    if (isEnabledUsers) {
      tabs.push(usersTab);
    }
    if (isEnabledWidget) {
      tabs.push(widgetTab);
    }
  }

  return tabs;
};
